import {useHotkeys} from 'react-hotkeys-hook';
import {useStore} from '@nanostores/react';
import {navigationState, SectionName} from '@/stores/navigationStore';

interface UseShortcutsOptions {
    onEnter?: () => void;
    onEscape?: () => void;
    onCtrlF?: () => void;
    onCtrlI?: () => void;
    onCtrlEnter?: () => void;
    enabledSections?: SectionName[];
    disabled?: boolean;
}

export const useShortcuts = ({
                                 onEnter,
                                 onEscape,
                                 onCtrlF,
                                 onCtrlI,
                                 onCtrlEnter,
                                 enabledSections,
                                 disabled = false
                             }: UseShortcutsOptions) => {
    const {currentSection} = useStore(navigationState);

    const isEnabled = !disabled && (!enabledSections || enabledSections.includes(currentSection));


    useHotkeys('enter',
        (event) => {
            // Если нажат Ctrl или Cmd, пропускаем этот обработчик
            if (event.ctrlKey || event.metaKey) return;

            if (!isEnabled || !onEnter) return;

            // Проверяем, находится ли фокус внутри Monaco Editor
            const target = event.target as HTMLElement;
            const isMonacoEditor = target.closest('.monaco-editor') !== null;

            // Если фокус в Monaco Editor, не перехватываем событие
            // Модалки теперь сами управляют фокусом при открытии
            if (isMonacoEditor) return;

            event.preventDefault();
            onEnter();
        },
        {
            enabled: isEnabled && !!onEnter,
            enableOnFormTags: true,
            enableOnContentEditable: true
        }
    );

    useHotkeys('escape',
        (event) => {
            if (!isEnabled || !onEscape) return;
            event.preventDefault();
            onEscape();
        }
    );

    useHotkeys('mod+f',
        (event) => {
            if (!isEnabled || !onCtrlF) return;
            event.preventDefault();
            onCtrlF();
        },
        {
            enabled: isEnabled && !!onCtrlF,
            enableOnFormTags: true,
            enableOnContentEditable: true
        }
    );

    useHotkeys('mod+i',
        (event) => {
            if (!isEnabled || !onCtrlI) return;
            event.preventDefault();
            onCtrlI();
        },
        {
            enabled: isEnabled && !!onCtrlI,
            enableOnFormTags: true,
            enableOnContentEditable: true
        }
    );

    useHotkeys('mod+enter',
        (event) => {
            if (!isEnabled || !onCtrlEnter) return;
            event.preventDefault();
            onCtrlEnter();
        },
        {
            enabled: isEnabled && !!onCtrlEnter,
            enableOnFormTags: true,
            enableOnContentEditable: true
        }
    );
};
